import { render, staticRenderFns } from "./LegacyAccountNotice.vue?vue&type=template&id=eb6563b0&scoped=true&"
import script from "./LegacyAccountNotice.vue?vue&type=script&lang=ts&"
export * from "./LegacyAccountNotice.vue?vue&type=script&lang=ts&"
import style0 from "./LegacyAccountNotice.vue?vue&type=style&index=0&id=eb6563b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6563b0",
  null
  
)

export default component.exports